var map = {
	"./": 149,
	"./6-max-hu-lost.json": 840,
	"./6-max-no-limit-no-hero.json": 841,
	"./6-max-pot-limit-no-hero.json": 842,
	"./6-max-short-hero-folded-pre.json": 843,
	"./index": 149,
	"./index.js": 149,
	"./play-money-no-draws.json": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 839;